import { plainToInstance } from 'class-transformer'
import { ObservationBase } from '@core/entities/observation/ObservationBase'
import { ILinkedObservationResult } from './ILinkedObservationResult'

export class LinkedObservationResult extends ObservationBase<ILinkedObservationResult> {
  questionId: string

  public static new(payload: unknown): LinkedObservationResult {
    const entity = plainToInstance(LinkedObservationResult, payload)

    return entity
  }
}
